<script>
  import {faTrashAlt, faEdit} from '@fortawesome/free-solid-svg-icons'
  import FilterHeader from '../generic/FilterHeader.vue'
  import LookupSelect from '../generic/LookupSelect.vue'
  import ReallyClick from '../generic/ReallyClick.vue'

  export default {
    components: {
      FilterHeader,
      LookupSelect,
      ReallyClick
    },
    data () {
      return {
        iconEdit: faEdit,
        iconDelete: faTrashAlt,
      }
    },
    computed: {
      items () {
        return this.$store.getters[this.store + '/list/items']
      },
    },
    mounted () {
      this.getPage()
    },
    methods: {
      getPage () {
        this.$store.dispatch(this.store + '/list/default')
      },
      deleteRow(item) {
        this.$store.dispatch(this.store + '/del/del', item).then(() => this.getPage())
      }
    },
    props: {
      store: {
        type: String,
        required: true
      },
      addRoute: {
        type: [String, Function],
        required: true
      },
      editRoute: {
        type: [String, Function],
        required: true
      }
    }
  }
</script>
<template>
  <b-container :fluid="true">
    <filter-header :storeNamespace="store" :addTo="(typeof addRoute === 'string') ? { name: addRoute } : addRoute()">
      <template v-slot:default="slotProps">
        <slot name="filter"></slot>
      </template>
    </filter-header>
    <b-list-group>
      <b-list-group-item>
        <b-row>
          <slot name="header">
            <b-col md="10"><strong>Item</strong></b-col>
          </slot>
          <b-col md="2"></b-col>
        </b-row>
      </b-list-group-item>
      <b-list-group-item v-for="(item, index) in items" :key="item['@id']" :variant="index % 2 ? 'dark' : 'light'">
        <b-row>
          <slot name="item" v-bind:item="item">
            <b-col md="10">{{ item }}</b-col>
          </slot>
          <b-col md="2">
            <really-click
              :title="$t('button.delete')"
              :message="store + '.messages.delete-confirm'"
              @click="deleteRow(item)"
              variant="danger"
            >
              <font-awesome-icon :icon="iconDelete" />
            </really-click>
            <b-button
              type="button"
              :title="$t('button.edit')"
              variant="success"
              :to="(typeof editRoute === 'string') ? {name: editRoute, params: { id: item['@id'] }} : editRoute(item)"
            >
              <font-awesome-icon :icon="iconEdit" />
            </b-button>
            <slot name="buttons" v-bind:item="item"></slot>
          </b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
  </b-container>
</template>
